/** Created by azhou on 2019/2/26.*/
<template>
  <div class="d-center-around">
    <rectangle-comp bgColor="#85B0E1">
      <h4>我的订单</h4>
      <p @click="$emit('goOrderLists',userInfo.type,'14')">待确认
        <span :class="{'text-danger':IndexData.confirm>0}">{{IndexData.confirm}}</span> 个</p>
      <p v-if="brand" @click="$emit('goOrderLists',userInfo.type,'7,8')">待收款
        <span :class="{'text-danger':IndexData.underWay>0}">{{IndexData.underWay}}</span> 个
      </p>
      <p v-if="brand" @click="$emit('goOrderLists',userInfo.type,'9')">
        已完成 <span>{{IndexData.over}}</span> 个
      </p>
      <p v-else @click="$emit('goOrderLists',userInfo.type,'6,8,9')">已完成
        <span>{{IndexData.over}}</span> 个</p>
    </rectangle-comp>
    <rectangle-comp bgColor="#80C9CE">
      <h4>{{brand ? '产品管理' : '门票管理'}}</h4>
      <div v-if="brand">
        <p @click="$router.push({name:'RoomMeetManage',query:{step:3}})">客房：{{IndexData.roomCount}} 个</p>
        <p @click="$router.push({name:'TicketManage'})">活动：{{IndexData.pass}} 个</p>
        <p @click="$router.push({name:'EateryManage'})">餐饮：{{IndexData.restaurant}} 个</p>
        <p @click="$router.push({name:'ActivityManage'})">行程：{{IndexData.itinerary}} 个</p>
      </div>
      <p v-else @click="$router.push({name:'TicketManage'})">已添加门票：<span>{{IndexData.pass + IndexData.verify}}</span> 种</p>
    </rectangle-comp>
    <rectangle-comp bgColor="#F8C26A">
      <h4>资金管理</h4>
      <p @click="$emit('goFinancial','allowWithdraw')">门店余额：<span>{{IndexData.money/100 | formatMoney}}</span> 元</p>
      <p @click="$emit('goFinancial','Freezing')">冻结金额：<span>{{IndexData.freezeMoney/100 | formatMoney}}</span> 元</p>
      <p @click="$emit('goFinancial','WithdrawDone')">累积提现：<span>{{IndexData.withdrawMoney/100 | formatMoney}}</span> 元</p>
    </rectangle-comp>
    <rectangle-comp bgColor="#b8a6d8">
      <h4>人事管理</h4>
      <p @click="$router.push({name:'PositionManage'})">职位数量 <span>{{IndexData.positionCount}}</span> 个</p>
      <p @click="$router.push({name:'StaffManage'})">人员数量 <span>{{IndexData.peopleCount}}</span> 个</p>
    </rectangle-comp>
  </div>
</template>

<script>
  import { mapGetters,mapState } from 'vuex'
  import RectangleComp from './RectangleComp'

  export default {
    name: 'SCenter',
    computed: {
      ...mapState(['IndexData']),
      ...mapGetters(['userInfo','brand'])
    },
    components: { RectangleComp },
  }
</script>
